import React, { useEffect, useState, useMemo, KeyboardEvent } from 'react';
import { CheckmarkAshIcon } from '@glu/icons-react';

let uniqueId = 0;

interface Props {
  checked?: boolean;
  classes?: {
    checkboxDisabled?: string;
    checkboxIcon?: string;
    checkboxLabelText?: string;
    checkboxRoot?: string;
    checkboxSelected?: string;
  };
  dataQa?: string;
  disabled?: boolean;
  htmlId?: string;
  htmlValue?: boolean | string | number;
  labelText?: string | JSX.Element;
  name?: string;
  onChange?(name: string, checked: boolean | string | number): void;
  onKeyDown?(event: KeyboardEvent): void;
  value?: boolean | string | number;
}

const Checkbox = (props: Props) => {
  const {
    checked = false,
    classes = {
      checkboxRoot: '',
      checkboxIcon: '',
      checkboxSelected: '',
      checkboxDisabled: '',
    },
    dataQa = '',
    disabled = false,
    htmlId = '',
    htmlValue = true,
    labelText,
    name = '',
    onChange,
    onKeyDown,
    value: fieldValue = false,
  } = props;

  // eslint-disable-next-line no-plusplus
  const [isSelected, setIsSelected] = useState(checked ? true : htmlValue === fieldValue);

  useEffect(() => {
    setIsSelected(checked ? true : htmlValue === fieldValue);
  }, [checked, fieldValue, htmlValue, isSelected]);

  const handleChange = ({ target: { checked: newChecked } }) => {
    setIsSelected(newChecked);
    onChange(name, newChecked ? htmlValue : newChecked);
  };

  // eslint-disable-next-line no-plusplus
  const id = useMemo(() => `${htmlId}-checkbox-radio-${uniqueId++}`, [htmlId]);
  return (
    <label
      className={`${classes.checkboxRoot} ${disabled ? classes.checkboxDisabled : ''}`}
      htmlFor={id}
      title={typeof labelText === 'string' ? labelText : labelText.props?.string}
    >
      <input
        checked={isSelected}
        data-qa={dataQa}
        disabled={disabled}
        id={id}
        name={name}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        type="checkbox"
        value={htmlValue as string}
      />
      <div className={`${classes.checkboxIcon} ${isSelected ? classes.checkboxSelected : ''} `}>
        {isSelected && <CheckmarkAshIcon />}
      </div>
      <span className={classes.checkboxLabelText}>{labelText}</span>
    </label>
  );
};

export default Checkbox;
